import * as React from 'react';

const SvgIcDebtsStatusButton = props => (
  <svg
    id="ic_debts_status_button_svg"
    width={props.size || 90}
    height={props.size || 90}
    viewBox="0 0 90 90"
    {...props}
  >
    <defs>
      <linearGradient
        id="debtsStatus_svg__a"
        x2={1}
        y2={1.031}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#f34c4c" />
        <stop offset={1} stopColor="#ffb100" />
      </linearGradient>
    </defs>
    <g data-name="Grupo 625">
      <path
        d="M3.624 0h82.752A3.624 3.624 0 0190 3.624v82.752A3.624 3.624 0 0186.376 90H3.624A3.624 3.624 0 010 86.376V3.624A3.624 3.624 0 013.624 0z"
        fill="url(#debtsStatus_svg__a)"
        data-name="Grupo 604"
      />
      <g data-name="bill (1)">
        <g data-name="Grupo 606">
          <g data-name="Grupo 605">
            <path
              data-name="Trazado 639"
              d="M67.656 43.62h-7.708V19.042a1.041 1.041 0 00-1.778-.737l-2.95 2.95-2.951-2.95a1.042 1.042 0 00-1.473 0l-2.95 2.95-2.951-2.95a1.042 1.042 0 00-1.473 0l-2.95 2.95-2.949-2.95a1.041 1.041 0 00-1.473 0l-2.955 2.951-2.945-2.951a1.042 1.042 0 00-1.473 0l-2.95 2.95-2.951-2.95a1.041 1.041 0 00-1.781.764v46.838a5.421 5.421 0 005.415 5.415h36.872a5.421 5.421 0 005.413-5.415V44.661a1.041 1.041 0 00-1.039-1.041zM26.415 69.24a3.336 3.336 0 01-3.333-3.333v-44.35l1.913 1.908a1.042 1.042 0 001.473 0l2.95-2.95 2.95 2.95a1.042 1.042 0 001.473 0l2.95-2.95 2.95 2.95a1.041 1.041 0 001.473 0l2.95-2.95 2.95 2.95a1.042 1.042 0 001.473 0l2.95-2.95 2.95 2.95a1.041 1.041 0 001.473 0l1.905-1.909v44.351a5.387 5.387 0 001.152 3.333H26.415zm40.2-3.333a3.333 3.333 0 11-6.665 0V45.7h6.665v20.2z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 608">
          <g data-name="Grupo 607">
            <path
              data-name="Trazado 640"
              d="M40.473 34.544a1.624 1.624 0 111.875-1.6 1.042 1.042 0 102.083 0 3.747 3.747 0 00-2.916-3.557v-.705a1.042 1.042 0 10-2.083 0v.705a3.747 3.747 0 00-2.912 3.552 3.834 3.834 0 003.957 3.688 1.624 1.624 0 11-1.875 1.605 1.042 1.042 0 10-2.083 0 3.747 3.747 0 002.916 3.557v.85a1.042 1.042 0 102.083 0v-.85a3.747 3.747 0 002.916-3.557 3.834 3.834 0 00-3.961-3.688z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 610">
          <g data-name="Grupo 609">
            <path
              data-name="Trazado 641"
              d="M50.937 34.544h-2.03a1.042 1.042 0 000 2.083h2.03a1.042 1.042 0 100-2.083z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 612">
          <g data-name="Grupo 611">
            <path
              data-name="Trazado 642"
              d="M32.039 34.544h-2.03a1.042 1.042 0 000 2.083h2.03a1.042 1.042 0 000-2.083z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 614">
          <g data-name="Grupo 613">
            <path
              data-name="Trazado 643"
              d="M51.463 46.12h-16.5a1.042 1.042 0 100 2.083h16.5a1.042 1.042 0 100-2.083z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 616">
          <g data-name="Grupo 615">
            <path
              data-name="Trazado 644"
              d="M30.22 46.425a1.041 1.041 0 10.305.736 1.049 1.049 0 00-.305-.736z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 618">
          <g data-name="Grupo 617">
            <path
              data-name="Trazado 645"
              d="M51.463 52.993h-16.5a1.042 1.042 0 100 2.083h16.5a1.042 1.042 0 100-2.083z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 620">
          <g data-name="Grupo 619">
            <path
              data-name="Trazado 646"
              d="M30.22 53.298a1.041 1.041 0 10.305.736 1.049 1.049 0 00-.305-.736z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 622">
          <g data-name="Grupo 621">
            <path
              data-name="Trazado 647"
              d="M51.463 59.864h-16.5a1.042 1.042 0 100 2.083h16.5a1.042 1.042 0 100-2.083z"
              fill="#fff"
            />
          </g>
        </g>
        <g data-name="Grupo 624">
          <g data-name="Grupo 623">
            <path
              data-name="Trazado 648"
              d="M30.22 60.172a1.041 1.041 0 10.305.736 1.049 1.049 0 00-.305-.736z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgIcDebtsStatusButton;
